import { Selector } from '@ngxs/store';
import _ from 'lodash';
import { BooleanOrgField, DateTimeOrgField, Int32OrgField, OrganisationEntryRemoteDto, StringOrgField } from '../../../../../generated/swagger';
import { DirectoryColumn } from '../../../../samwebDescription/samweb/directory/directory-column';
import { DirectoryOrganisationDataState } from '../directory-organisation-data/directory-organisation-data.state';
import { DirectoryStructureState } from './directory-structure.state';

export class DirectoryStructureSelectors {
   @Selector([DirectoryOrganisationDataState.getOrganisationEntryForOrganisationUnit, DirectoryStructureState.getParentStructureForStructureNumber])
   public static getOrganisationDataEntryForDirectoryColumn(
      getOrganisationEntryForOrganisationUnit: (organisationUnitNumber: string, subscriberStructureValue: number) => OrganisationEntryRemoteDto,
      getParentStructureForStructureNumber: (organisationUnitNumber: string) => string
   ): (organisationEntryRemoteDto: OrganisationEntryRemoteDto, organisationUnitNumber: string) => OrganisationEntryRemoteDto {
      const recursiveFn = (organisationEntryRemoteDto: OrganisationEntryRemoteDto, organisationUnitNumber: string, testME = false) => {
         const parentStructure = getParentStructureForStructureNumber(organisationUnitNumber);
         if (!_.isNil(parentStructure)) {
            organisationEntryRemoteDto = recursiveFn(organisationEntryRemoteDto, parentStructure);
         }
         if (organisationUnitNumber === '00') {
            return organisationEntryRemoteDto;
         }
         if (organisationUnitNumber === '01' && !_.isNil(organisationEntryRemoteDto?.org01?.value)) {
            return getOrganisationEntryForOrganisationUnit('01', organisationEntryRemoteDto.org01.value);
         }
         if (organisationUnitNumber === '02' && !_.isNil(organisationEntryRemoteDto?.org02?.value)) {
            return getOrganisationEntryForOrganisationUnit('02', organisationEntryRemoteDto.org02.value);
         }
         if (organisationUnitNumber === '03' && !_.isNil(organisationEntryRemoteDto?.org03?.value)) {
            return getOrganisationEntryForOrganisationUnit('03', organisationEntryRemoteDto.org03.value);
         }
         if (organisationUnitNumber === '04' && !_.isNil(organisationEntryRemoteDto?.org04?.value)) {
            return getOrganisationEntryForOrganisationUnit('04', organisationEntryRemoteDto.org04.value);
         }
         if (organisationUnitNumber === '05' && !_.isNil(organisationEntryRemoteDto?.org05?.value)) {
            return getOrganisationEntryForOrganisationUnit('05', organisationEntryRemoteDto.org05.value);
         }
         if (organisationUnitNumber === '06' && !_.isNil(organisationEntryRemoteDto?.org06?.value)) {
            return getOrganisationEntryForOrganisationUnit('06', organisationEntryRemoteDto.org06.value);
         }
         if (organisationUnitNumber === '07' && !_.isNil(organisationEntryRemoteDto?.org07?.value)) {
            return getOrganisationEntryForOrganisationUnit('07', organisationEntryRemoteDto.org07.value);
         }
         if (organisationUnitNumber === '08' && !_.isNil(organisationEntryRemoteDto?.org08?.value)) {
            return getOrganisationEntryForOrganisationUnit('08', organisationEntryRemoteDto.org08.value);
         }
         if (organisationUnitNumber === '09' && !_.isNil(organisationEntryRemoteDto?.org09?.value)) {
            return getOrganisationEntryForOrganisationUnit('09', organisationEntryRemoteDto.org09.value);
         }
         if (organisationUnitNumber === '10' && !_.isNil(organisationEntryRemoteDto?.org10?.value)) {
            return getOrganisationEntryForOrganisationUnit('10', organisationEntryRemoteDto.org10.value);
         }
         if (organisationUnitNumber === '11' && !_.isNil(organisationEntryRemoteDto?.org11?.value)) {
            return getOrganisationEntryForOrganisationUnit('11', organisationEntryRemoteDto.org11.value);
         }
         if (organisationUnitNumber === '12' && !_.isNil(organisationEntryRemoteDto?.org12?.value)) {
            return getOrganisationEntryForOrganisationUnit('12', organisationEntryRemoteDto.org12.value);
         }
         if (organisationUnitNumber === '13' && !_.isNil(organisationEntryRemoteDto?.org13?.value)) {
            return getOrganisationEntryForOrganisationUnit('13', organisationEntryRemoteDto.org13.value);
         }
         if (organisationUnitNumber === '14' && !_.isNil(organisationEntryRemoteDto?.org14?.value)) {
            return getOrganisationEntryForOrganisationUnit('14', organisationEntryRemoteDto.org14.value);
         }
         if (organisationUnitNumber === '15' && !_.isNil(organisationEntryRemoteDto?.org15?.value)) {
            return getOrganisationEntryForOrganisationUnit('15', organisationEntryRemoteDto.org15.value);
         }
         if (organisationUnitNumber === '16' && !_.isNil(organisationEntryRemoteDto?.org16?.value)) {
            return getOrganisationEntryForOrganisationUnit('16', organisationEntryRemoteDto.org16.value);
         }
         if (organisationUnitNumber === '17' && !_.isNil(organisationEntryRemoteDto?.org17?.value)) {
            return getOrganisationEntryForOrganisationUnit('17', organisationEntryRemoteDto.org17.value);
         }
         if (organisationUnitNumber === '18' && !_.isNil(organisationEntryRemoteDto?.org18?.value)) {
            return getOrganisationEntryForOrganisationUnit('18', organisationEntryRemoteDto.org18.value);
         }
         if (organisationUnitNumber === '19' && !_.isNil(organisationEntryRemoteDto?.org19?.value)) {
            return getOrganisationEntryForOrganisationUnit('19', organisationEntryRemoteDto.org19.value);
         }
         if (organisationUnitNumber === '20' && !_.isNil(organisationEntryRemoteDto?.org20?.value)) {
            return getOrganisationEntryForOrganisationUnit('20', organisationEntryRemoteDto.org20.value);
         }
      };
      return recursiveFn;
   }

   @Selector([DirectoryStructureSelectors.getOrganisationDataEntryForDirectoryColumn])
   public static getColumnInstance(
      getOrganisationDataEntryForDirectoryColumn
   ): (
      organisationEntryRemoteDto: OrganisationEntryRemoteDto,
      directoryColumn: DirectoryColumn
   ) => Int32OrgField | DateTimeOrgField | BooleanOrgField | StringOrgField {
      return (organisationEntryRemoteDto: OrganisationEntryRemoteDto, directoryColumn: DirectoryColumn) => {
         const targetOrganisationEntryRemoteDto = getOrganisationDataEntryForDirectoryColumn(
            organisationEntryRemoteDto,
            directoryColumn?.organisationUnitNumber
         );
         return directoryColumn?.columnTyp?.valueForColumnInstance(targetOrganisationEntryRemoteDto);
      };
   }
}
